var _defs, _circle, _rect, _circle2, _circle3, _circle4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserFriendlyInterface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_51",
    "data-name": "Layer 51",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #15233f;\n      }\n\n      .cls-3 {\n        fill: #c2c7cc;\n        opacity: .25;\n      }\n\n      .cls-4 {\n        fill: #4f7fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 250,
    cy: 250,
    r: 162.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75,
    y: 109.08,
    width: 359,
    height: 298.5,
    rx: 8,
    ry: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 349,
    cy: 139.37,
    r: 12
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 378,
    cy: 139.37,
    r: 12
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 407,
    cy: 139.37,
    r: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M340,337.59h-175c0-39.65,26.39-73.16,62.57-83.89-13.21-8.31-21.99-23-21.99-39.76,0-25.91,21.01-46.92,46.92-46.92s46.92,21.01,46.92,46.92c0,16.75-8.78,31.45-21.99,39.76,36.18,10.73,62.57,44.23,62.57,83.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.77,379.26c-4.83,0-9.68-1.68-13.6-5.08l-47.65-41.27c-8.68-7.51-9.62-20.64-2.1-29.33,7.52-8.66,20.65-9.62,29.32-2.1l32.7,28.32,67.09-70.05c7.95-8.31,21.1-8.58,29.4-.64,8.29,7.93,8.57,21.1.64,29.39l-80.77,84.34c-4.07,4.26-9.54,6.42-15.02,6.42Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserFriendlyInterface);
export default __webpack_public_path__ + "static/media/icon_user_friendly_interface.040f10fd3880c32d88be0beef0d8b823.svg";
export { ForwardRef as ReactComponent };